import config from '../../config/customer.api'
import { DealerSalesClassEnum } from '../../src/shared/enums/dealer.sales.class.enum.js'
import {
  Request
} from '../shared/base.requests'

const inventoryModule = {
  namespaced: true,
  state: {
    invetoryList: null,
    providerType: null,
    currentVehicale: null,
    makes: [],
    models: [],
    trims: [],
    bodys: ['Suv', 'Truck', 'Sedan', 'Van', 'Convertible'],
    filter: {
      isUsed: null,
      model: null,
      make: null,
      size: 12,
      page: 1,
      transmission: null,
      color: null,
      bodyType: null,
      yearFrom: null,
      yearTo: null,
      priceFrom: null,
      priceTo: null,
      trim: null,
      sort: null,
      search: null
    },
    specials: []
  },
  mutations: {
    setFilterIsUsedAndSortBySalesClass (state, data) {
      state.filter.isUsed = data !== DealerSalesClassEnum.NewOnly
      state.filter.sort = state.filter.isUsed ? 'price_asc' : 'added_asc'
    },
    setFilter (state, data) {
      state.filter = data
    },
    setVehicalList (state, data) {
      state.invetoryList = data.itemList
    },
    setVehical (state, data) {
      state.currentVehicale = data
      console.log(state.currentVehicale)
    },
    setMakes (state, data) {
      state.makes = data
    },
    setModels (state, data) {
      state.models = data
    },
    setTrims (state, data) {
      state.trims = data
    },
    updateFilter (state, data) {
      state.filter = data
    },
    setProviderType (state, data) {
      console.log('provider type:', data.providerType)
      state.providerType = data.providerType
    },
    setSpecials (state, data) {
      state.specials = data
    },
    toggleFavorite (state, vehicleId) {
      if (state.currentVehicale.id === vehicleId) {
        state.currentVehicale.isFavorite = !state.currentVehicale.isFavorite
      }
    }
  },
  actions: {
    loadVehicalList: function (context) {
      return new Promise((resolve, reject) => {
        console.log('rootState: ' + context.rootState.common.salesClass)
        Request.GetFromCache(config.getHomePageSettings, function (response) {
          if (context.state.filter.isUsed === null) {
            context.commit('setFilterIsUsedAndSortBySalesClass', response.model.salesClass)
            context.commit('inventoryVautoFilter/setFilterIsUsedAndSortBySalesClass', response.model.salesClass, { root: true })
          }
          Request.post(config.inventoryList, context.state.filter)
            .then(response => {
              context.commit('setVehicalList', response.model)
              context.commit('setProviderType', response.model)
              resolve()
            })
            .catch(error => {
              console.error('loadVehicalList failed', error)
              reject()
            })
        })
      })
    },
    loadMakes: function (context) {
      return new Promise((resolve, reject) => {
        Request.get(config.getMakes, {
         // salesclass: context.state.filter.isUsed ? 'used' : 'new'
        })
          .then(response => {
            context.commit('setMakes', response.model)
            context.commit('setModels', [])
            context.commit('setTrims', [])
            resolve()
          })
          .catch(error => {
            console.error('loadMakes failed', error)
            reject()
          })
      })
    },
    loadModels: function (context) {
      return new Promise((resolve, reject) => {
        Request.get(config.getModels, {
         // salesclass: context.state.filter.isUsed ? 'used' : 'new',
          make: context.state.filter.make
        })
          .then(response => {
            context.commit('setModels', response.model)
            context.commit('setTrims', [])
            resolve()
          })
          .catch(error => {
            console.error('load Models failed', error)
            reject()
          })
      })
    },
    loadTrims: function (context) {
      return new Promise((resolve, reject) => {
        Request.get(config.getTrims, {
         // salesclass: context.state.filter.isUsed ? 'used' : 'new',
          make: context.state.filter.make,
          model: context.state.filter.model
        })
          .then(response => {
            context.commit('setTrims', response.model)
            resolve()
          })
          .catch(error => {
            console.error('load Trims failed', error)
            reject()
          })
      })
    },
    updateFilter: function (context, data) {
      console.log(data)
      context.commit('updateFilter', data)
    },
    updateFilterToDefault: function (context, data) {
      context.commit('updateFilter', data)
      context.commit('setModels', [])
      context.commit('setTrims', [])
    },
    loadCurrentVehical: function (context, data) {
      return new Promise((resolve, reject) => {
        Request.get(config.getCurrentVehical, {
          id: data
        })
          .then(response => {
            context.commit('setVehical', response.model)
            resolve()
          })
          .catch(error => {
            console.error('load Vehical failed', error)
            reject()
          })
      })
    },
    getVehiclesVauto (context, filter) {
      console.log(filter)
      return new Promise((resolve, reject) => {
        Request.post(config.getInventoryDynamic, filter)
          .then(response => {
            context.commit('setVehicalList', response.model)
            resolve()
          })
          .catch(error => {
            console.error('loadVehicalList failed', error)
            reject()
          })
      })
    },
    loadSpecials (context, filter) {
      return new Promise((resolve, reject) => {
        Request.post(config.getSpecials, filter)
          .then(response => {
            context.commit('setSpecials', response.model)
            resolve()
          })
          .catch(error => {
            console.error('load specials failed', error)
            reject()
          })
      })
    },
    toggleFavorite ({commit}, data) {
      commit('toggleFavorite', data.vehicleId)
      return new Promise((resolve, reject) => {
        Request.post(config.toggleFavorite, data).then((res) => {
          resolve(res.model)
        }).catch(err => {
          console.error('Toggle vehicle favorite error:', err)
          reject()
        })
      })
    }
  },
  getters: {
    getFilterModel: state => {
      return Object.assign({}, state.filter)
    },
    getSpecials: state => {
      return Object.assign({}, state.specials)
    }
  }
}

export default inventoryModule



// WEBPACK FOOTER //
// ./scripts/src/store/inventory.module.js